// @flow
import type { AppState } from 'quick-quote/reducers'

import { compose } from 'recompose'
import { Button } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import MESSAGES from 'core/data-model/constants/messages'
import { setAcceptIlpSaleSheet } from 'quick-quote/ui/actions'

type Props = {
  handleSetAcceptIlpSaleSheet: () => void,
  disabled?: boolean,
}

export const _AcceptIlpSaleSheetButton = (props: Props) => {
  return (
    <Button
      color="primary"
      onClick={() => {
        props.handleSetAcceptIlpSaleSheet()
      }}
      disabled={props.disabled}
    >
      {MESSAGES.SUBMIT}
    </Button>
  )
}

const mapStateToProps = (state: AppState) => ({})

const mapDispatchToProps = (dispatch: Dispatch<*>) => ({
  handleSetAcceptIlpSaleSheet: bindActionCreators(setAcceptIlpSaleSheet, dispatch),
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(_AcceptIlpSaleSheetButton)
